import { BaseRepository } from "../../../../infrastructure/BaseRepository";
import authClaimsResource from "../resources/AuthClaimsResource";

class AuthClaimsRepository extends BaseRepository {
  constructor() {
    super(authClaimsResource)
  }

  sendVerification() {
    return this.resource('send_verify')
      .create().then((res) => this.processResponse(res));
  }
  
  public checkHeaders() {
    return this.resource('check_headers')
      .get().then((res) => this.processResponse(res));
  }
}

const authClaimsRepository = new AuthClaimsRepository();

export default authClaimsRepository; 


// WEBPACK FOOTER //
// ./src/app/modules/auth/domain/repositories/AuthClaimsRepository.ts